<template>
  <div v-if="visible" class="modal-overlay" @click.self="close">
    <div class="modal-container glass-modal-container modal-image">
      <div class="modal-header glass-modal-header">
        <h3>{{ document.title || 'Document' }}</h3>
        <button class="modal-close" @click="close">×</button>
      </div>
      <div class="modal-body">
        <iframe v-if="isPdf" :src="documentUrl" class="document-viewer"></iframe>
        <img v-else :src="documentUrl" class="modal-image-img" />
        <div class="document-notes" v-if="document.notes">
          <strong>Notes:</strong> {{ document.notes }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'DocumentViewerModal',
  props: {
    visible: { type: Boolean, default: false },
    document: { type: Object, default: null }
  },
  emits: ['close'],
  setup(props, { emit }) {
    const documentUrl = computed(() => {
      if (!props.document.file_path) return ''
      const path = props.document.file_path
      return path.startsWith('http') ? path : '/' + path
    })
    
    const isPdf = computed(() => {
      return documentUrl.value && documentUrl.value.toLowerCase().endsWith('.pdf')
    })
    
    const close = () => emit('close')
    
    return { documentUrl, isPdf, close }
  }
}
</script>

<style scoped>
.document-viewer {
  width: 100%;
  height: 70vh;
  border: none;
  border-radius: 8px;
}

.document-notes {
  margin-top: 16px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 8px;
  font-size: 13px;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/DisputedOrders/components/DocumentViewerModal.vue